



export const studentTestimonial = [
    {
        "name": "- Arun",
        "testimonial": "Professor Devindra is a patient, motivating and excellent tutor. He immediately understood the flaws in my writing and study habits and worked tirelessly with me to improve each area. Thanks to him, I've made a complete turn-around in my performance in both high school and college."
    },
    {
        "name": "- Kieran",
        "testimonial": "Professor Devindra was a great help to me throughout my high school admissions process. His approach to teaching really helped me to understand the content of the tests. With his help, I was able to exceed all of my admissions expectations."
    },
    {
        "name": "- Nicholas",
        "testimonial": " He was very encouraging and helped me through the entire process step-by-step."
    },
    {
        "name": "- J.R",
        "testimonial": "Thank you for spending time with me and tutoring me for the TACHS and ISEE tests. I don't think I would have been able to do that on my own."
    },
    {
        "name": "- Ganga",
        "testimonial": "Professor Devindra gave me the foundational tools to become an excellent student in college. Thanks to him, I excelled in my studies as a nurse."
    },
    {
        "name": "- Kasia",
        "testimonial": "Professor Devindra really helped me tackle the SAT, question-by-question and topic-by-topic in both Math and English. He improved my study habits and helped me become a more organized student."
    },
    {
        "name": "- Sam",
        "testimonial": "Mr. Williams was a great tutor who taught me fundamental academic skills.  He was always prepared with an agenda for the day, and was very approachable when I had concerns.  He gave me the feeling that he genuinely cared about my performance, and would lucidly identify topics which held me back.  In all, Mr. Williams prepared me very well for college and remains close to my family to this day."
    }
]

export const parentTestimonial = [
    {
        "name": "- Geetha",
        "testimonial": "I am extremely grateful for Professor Devindra. He was a key figure in ensuring my son's success throughout his high school and college career. My son's academic achievements were stellar and Professor Devindra kept him adhered to a consistent plan. Thanks to him, my son bears a dual degree in both Computer Science and Biomedical Engineering."
    },
    {
        "name": "- Marcus",
        "testimonial": "Professor Devindra came highly recommended to us, and engaging him as a tutor for both of our children, for both the high school and college entrance exams, was the best thing we could have done throughout the entire process. Professor Devindra does not simply work with developing the intellect, but rather brings an intuitive understanding of what young people need in general when facing stressful and difficult tests. He is generous where he needs to be; sympathetic to the student's individual idiosyncrasies; firm when confronted with laziness or apathy; and above all else encouraging, experienced, and gracious. I cannot commend Professor Devindra highly enough for giving my children the benefit of his astute insight, also for the great scores they achieved."
    },
    {
        "name": "- Sejal",
        "testimonial": "We really appreciate all the help Professor Devindra was able to give both of our children as they prepared for their HS admissions tests and interviews. With his help, they received admissions to several top high schools in New York City. His attention to detail and systematic progressions allowed for true learning of material and test-taking strategies. Thanks Professor Devindra."
    },
    {
        "name": "- Brooke",
        "testimonial": "Professor Devindra helped us immensely throughout our son's high school exam and application prep. His improvement over the time they worked together was evident in his school acceptances and scholarship offers. His unique methods made our son look forward to their sessions. professor Devindra personalized attention and sincere interest in our son's academic success made all the difference."
    },
    {
        "name": "- Shane",
        "testimonial": "Professor Devindra is an excellent tutor. In his first session with my daughter, he broke down the sections of the SAT and laid out a plan to help her improve her score. I highly recommend him."
    },
    {
        "name": "- Paola",
        "testimonial": "By assessing my children's strengths and weaknesses, Professor Devindra was able to tailor his sessions to meet the needs of each of them. This allowed them to get into the Universities of their dreams (University of Chicago and Northeastern University)."
    },
    {
        "name" : "- N.R",
        "testimonial": "My two children were tutored by Professor Devindra over a 3-4 year period. It was for different tests, and I always found him to be prompt, courteous and knowledgeable. He worked very well with my children, and their grades reflect that. I appreciated his advice, and highly recommend Professor Devindra as a smart and qualified tutor. I always enjoyed watching him work with our children."
    }
]